/**
 * @fileoverview Banking data API call.
 * @description Wraps GET /banking/data.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { httpClient } from '@/shared/api/http-client'

import type { BankDataPayload } from '@/features/banking/types/banking.types'

/**
 * @description Fetches the full banking dataset every page derives its numbers from.
 * @returns {Promise<BankDataPayload>} The full dataset.
 */
export async function getBankingData(): Promise<BankDataPayload> {
  const { data } = await httpClient.get<BankDataPayload>('/banking/data')
  return data
}
